import React, { Component, Fragment } from "react";
import api from "../../../services/api";
import * as CONSTANTS from "../../../services/constants";
import moment from "moment";
import "./styles.css";
import ModalAlert from "../../common/modal-alert";
import ModalConfirm from "../../common/modal-confirm";
import DropMonthYear from "../../../components/DropMonthYear";

class Company extends Component {
  state = {
    load: false,
    documentsToUpload: {},
    employeeDocuments: {},
    showAprovacao: true,
    erroDelete: false,
    rejectDocument: false,
    dataEmployee: {},
    employeeStatusId: null,
    msgFile: "",
    year: moment().format("YYYY"),
    month: CONSTANTS.months()[CONSTANTS.currMonth()]
  };

  async componentDidMount() {
    await this.searchDataEmployee();
    await this.searchDocumentsEmployee();
    await this.searchDocumentsToEmployee();
  }

  searchDataEmployee = async () => {
    const dataEmployee = await api.get(
      `/employees?CompanyId=${localStorage.getItem("CompanyId")}`
    );

    if (dataEmployee.data.rows.length) {
      let employee = dataEmployee.data.rows.filter(
        e => e.id == parseInt(this.props.match.params.id)
      );
      if (employee.length > 0)
        this.setState({
          dataEmployee: employee[0],
          EmployeeStatus: employee[0].EmployeeStatus.description
        });
    }
  };

  searchDocumentsEmployee = async () => {
    if (this.state.dataEmployee) {
      const { year, month } = this.state;

      const employeeDocuments = await api.get(
        `/employees/${this.props.match.params.id}/attachments?DocumentTypeId=4&year=${year}&month=${month}`
      );
      this.setState({ employeeDocuments: employeeDocuments.data.rows });
      console.log(
        "TCL: Company -> searchDocumentsEmployee -> employeeDocuments",
        this.state.employeeDocuments
      );
    }
  };

  searchDocumentsToEmployee = async () => {
    const companyTypeDocuments = await api.get(
      `/company-types/${localStorage.getItem(
        "CompanyTypeId"
      )}/documents?DocumentTypeId=4`
    );
    this.setState({ documentsToUpload: companyTypeDocuments.data.data });
    this.sendApproval();
    this.verifyStatusEmployee();
    this.verifyStatusDocuments();
  };

  verifyDocument = id => {
    const exist = this.state.employeeDocuments.filter(
      item => item.DocumentId === id
    );
    return exist.length > 0 ? exist[0].originalName : "";
  };

  verifyDocumentNote = id => {
    const exist = this.state.employeeDocuments.filter(
      item => item.DocumentId === id
    );
    return exist.length > 0 ? exist[0].note : "";
  };

  verifyDocumentExpired = id => {
    const exist = this.state.employeeDocuments.filter(
      item => item.DocumentId === id
    );
    if (exist.length > 0) {
      if (exist[0].expired) {
        return "Vencido";
      }
    }
  };

  verifyDocumentApplicable = id => {
    const exist = this.state.employeeDocuments.filter(
      item => item.DocumentId == id
    );
    return exist.length ? exist[0].notapplicable : false;
  };

  //Método para setar os documentos como não aplicáveis
  checkDocument = async e => {
    this.setState({ msgFile: "", load: true });
    const { year, month } = this.state;
    if (year && month) {
      const data = {
        DocumentId: e.target.value,
        notapplicable: e.target.checked ? true : false,
        year: year,
        month: month
      };
      console.log("TCL: Company -> data", data)

      await api
        .post(
          `/employees/${this.props.match.params.id}/attachments`,
          data
        )
        .then(response => {
          document.getElementById("modal-alert").click();
          this.setState({
            msgAlert: response.data.msg,
            classText: "text-success",
            load: false
          });
          this.searchDocumentsEmployee();
          this.searchDocumentsToEmployee();
        })
        .catch(err => {
          if (err) {
            this.setState({
              msgAlert: err.response.data.msg,
              classText: "text-danger"
            });
          } else {
            this.setState({
              msgAlert: "Erro no envio. Tente novamente!",
              classText: "text-danger"
            });
          }
        });
    } else {
      document.getElementById(`${e.target.id}`).value = "";
      document.getElementById("modal-alert").click();
      this.setState({
        msgAlert: "Selecione o mês e ano de competência dos documentos!",
        classText: "text-danger",
        load: false
      });
    }
  };

  uploadDocument = async e => {
    this.setState({ load: true });
    // Status 4 : Rejeitado
    const rejectedDocument = this.state.employeeDocuments.filter(
      item => item.AttachmentStatusId === 4
    );
    const { year, month } = this.state;

    if (year && month) {
      if (e.target.files.length > 0) {
        // var nameFile = e.target.files[0].name.split(".");
        // var nameFileTrat = nameFile[nameFile.length - 1];

        // var arrayTypeFiles = [
        //   "txt",
        //   "pdf",
        //   "doc",
        //   "docx",
        //   "xlsx",
        //   "xls",
        //   "png",
        //   "jpg",
        //   "jpeg"
        // ];
        // var idx = arrayTypeFiles.indexOf(nameFileTrat);
        // this.setState({ msgFile: "" });
        // if (idx !== -1) {
        const formData = new FormData();
        formData.append("attachment", e.target.files[0]);
        formData.append("DocumentId", e.target.id);
        formData.append("year", year);
        formData.append("month", month);
        formData.append(
          "notapplicable",
          this.verifyDocumentApplicable(e.target.id)
        );
        const config = {
          headers: {
            "content-type": "multipart/form-data"
          }
        };
        document.getElementById("modal-alert").click();

        try {
          let response = null;
          if (
            rejectedDocument.length > 0
              ? (response = await api.patch(
                  `/employees/${this.props.match.params.id}/newattachment`,
                  formData,
                  config
                ))
              : (response = await api.post(
                  `/employees/${this.props.match.params.id}/attachments`,
                  formData,
                  config
                ))
          )
            this.setState({
              msgAlert: response.data.msg,
              classText: "text-success",
              load: false
            });
          await this.searchDocumentsEmployee();
          await this.searchDocumentsToEmployee();
        } catch (err) {
          if (err && err.response.data.errors) {
            console.log("TCL: Company -> err", err);
            this.setState({
              msgAlert: err.response.data.errors[0].msg,
              classText: "text-danger"
            });
          } else {
            this.setState({
              msgAlert: "Erro no envio. Tente novamente!",
              classText: "text-danger"
            });
          }
        }
        // } else {
        //   this.setState({
        //     msgFile:
        //       "Faça upload apenas as extensões: " +
        //       arrayTypeFiles.map(i => i + " ")
        //   });
        // }
      }
    } else {
      document.getElementById(`${e.target.id}`).value = "";
      document.getElementById("modal-alert").click();
      this.setState({
        msgAlert: "Selecione o mês e ano de competência dos documentos!",
        classText: "text-danger",
        load: false
      });
    }
  };

  verifyDocumentIcon = id => {
    const exist = this.state.employeeDocuments.filter(
      item => item.DocumentId === id
    );
    if (exist.length) {
      const status = exist[0].AttachmentStatusId;
      if (status === 1) {
        return "fa fa-clock-o";
      } else if (status === 2) {
        return "fa fa-check text-success";
      } else if (status === 4) {
        return "fa fa-times text-danger";
      }
    } else {
      return "fa fa-circle-thin";
    }
  };

  sendApproval = async () => {
    const { employeeDocuments, documentsToUpload, year, month } = this.state;
    // Retorna só os documentos cuja o tipo seja "Colaborador Periódico"
    const employeeDocumentsTrat = employeeDocuments.filter(
      item => item.Document.DocumentTypeId === 4
    );
    const allDocumentsInDateAlreadySubmited = employeeDocuments.filter(
      item =>
        item.AttachmentStatusId === 2 &&
        item.Document.DocumentTypeId === 4 &&
        item.year === year &&
        item.month === month
    );

    // Valida se os docs já enviados são maiores ou igual do que os docs a serem submetidos
    if (employeeDocuments.length >= documentsToUpload.length) {
      this.setState({ showAprovacao: true });
    } else {
      this.setState({ showAprovacao: false });
    }

    // Valida se os docs a serem enviados/selecionados possuem a mesma qtde dos documentos do tipo COLABORADOR PERIODICO
    if (documentsToUpload.length === employeeDocumentsTrat.length) {
      this.setState({ showAprovacaoPeriodic: true });
    } else {
      this.setState({ showAprovacaoPeriodic: false });
    }

    if (documentsToUpload.length === allDocumentsInDateAlreadySubmited.length) {
      console.log(
        " documentsToUpload.length, allDocumentsInDateAlreadySubmited.length",
        documentsToUpload,
        allDocumentsInDateAlreadySubmited
      );
      this.setState({ allDocumentsInDateAlreadySubmited: true });
    } else {
      this.setState({ allDocumentsInDateAlreadySubmited: false });
    }
  };

  verifyStatusEmployee = async e => {
    await api.get(`/employees/${this.props.match.params.id}`).then(result => {
      this.setState({ employeeStatusId: result.data.EmployeeStatusId });
    });
  };

  confirmAlterStatusEmployee = async e => {
    this.setState({ erroDelete: null });
    document.getElementById("modal-confirm").click();
  };

  alterStatusEmployee = async e => {
    this.setState({ load: true });
    const ids = this.state.documentsToUpload.map(doc => doc.id);

    await api
      .patch(`/employees/${this.props.match.params.id}`, {
        EmployeeStatusId: 2,
        isPeriodicDocument: true,
        DocumentIds: ids
      })
      .then(result => {
        this.setState({ load: false, erroDelete: null });
        document.getElementById("close-modal-confirm").click();
        document.getElementById("modal-alert").click();
        this.setState({ msgAlert: result.data.msg, classText: "text-success" });
        this.searchDocumentsEmployee();
        this.searchDocumentsToEmployee();
        this.searchDataEmployee();
      })
      .catch(err => {
        if (err && err.response.data.errors[0]) {
          this.setState({
            msgAlert: err.response.data.errors[0].msg,
            classText: "text-danger"
          });
        } else {
          this.setState({
            msgAlert: "Erro no envio. Tente novamente!",
            classText: "text-danger"
          });
        }
      });
  };

  verifyStatusDocuments = () => {
    const exist = this.state.employeeDocuments.filter(
      item => item.AttachmentStatusId === 4
    );
    this.setState({ rejectDocument: exist.length > 0 ? true : false });
  };

  /* 
     Status 1 = Envio de documentos - Não pode 
     Status 2 = Aprovação de documentos - Não pode
     Status 3 = Documentos rejeitados - Pode
     Status 4 = Pendente de integração - Não pode
     Status 5 = Habilitado - Pode* a não ser que já não tenha sido aprovado
     Status 6 = Desabilitado - Não pode
   */
  showFileButton = id =>
    (this.state.employeeStatusId === 5) &&
    this.verifyDocumentIcon(id) !== "fa fa-check text-success"
      ? true
      : false;

  // Para mostrar o botão de Enviar para aprovação
  showSubmitButtonByStatusCompany = () => {
    const {
      employeeStatusId,
      showAprovacaoPeriodic,
      allDocumentsInDateAlreadySubmited,
      rejectDocument,
      employeeDocuments,
      documentsToUpload,
      year,
      month
    } = this.state;

    const countNumberOfSendedDocument =
      employeeDocuments.length &&
      employeeDocuments.filter(
        item =>
          item.AttachmentStatusId === 1 ||
          (item.AttachmentStatusId === 2 &&
            item.Document.DocumentTypeId === 4 &&
            item.year === year &&
            item.month === month)
      ).length;

    /**
     * Status 1 = Envio de documentos
     * Status 2 = Aprovação de documentos
     * Status 3 = Documentos da empresa rejeitados
     * Status 4 = Pendente de integração
     * Status 5 = Habilitado
     * Status 6 = Desativado
     * showAprovacaoPeriodic = Se todos os documentos periódicos pendentes de envio já foram selecionados
     */
    if (employeeStatusId === 1 || employeeStatusId === 2) {
      console.log(
        "Status: Envio de documento ou Aprovação de documentos do colaborador"
      );
      return false;
    } else if (
      showAprovacaoPeriodic &&
      employeeStatusId === 5 &&
      !allDocumentsInDateAlreadySubmited
    ) {
      console.log(
        "Case: Todos arquivos foram selecionados / employeeStatusId - Habilitado / confere se todos os documentos da data foram enviados",
        showAprovacaoPeriodic,
        employeeStatusId,
        allDocumentsInDateAlreadySubmited
      );
      return true;
    } else if (allDocumentsInDateAlreadySubmited) {
      console.log(
        "Case: Todos os documentos foram enviados nesta data selecionada",
        allDocumentsInDateAlreadySubmited
      );
      return false;
    // } else if (
    //   !rejectDocument &&
    //   countNumberOfSendedDocument === documentsToUpload.length &&
    //   employeeStatusId === 3
    // ) {
    //   console.log(
    //     "Case: já foi selecionado o documento e o status está como rejeitado",
    //     !rejectDocument,
    //     countNumberOfSendedDocument,
    //     documentsToUpload.length
    //   );
    //   return true;
    } else if (countNumberOfSendedDocument !== documentsToUpload.length)
      console.log(
        "Nenhuma das opções",
        employeeStatusId,
        showAprovacaoPeriodic,
        allDocumentsInDateAlreadySubmited
      );

    return false;
  };

  handleChangeDate = async e => {
    const { name, value } = e.target;
    const { documentsToUpload } = this.state;

    this.setState({ [name]: value }, async () => {
      const { year, month } = this.state;

      const employeeDocuments = await api.get(
        `/employees/${this.props.match.params.id}/attachments?DocumentTypeId=4&year=${year}&month=${month}`
      );

      this.setState((state, props) => ({
        ...state,
        employeeDocuments: employeeDocuments.data.rows || {},
        allDocumentsInDateAlreadySubmited:
          employeeDocuments.data.rows.filter(
            item =>
              item.AttachmentStatusId === 2 &&
              item.Document.DocumentTypeId === 4 &&
              item.year === year &&
              item.month === month
          ).length === documentsToUpload.length
      }));
      this.forceUpdate();
    });
  };
  render() {
    const {
      year,
      month,
      load,
      dataEmployee,
      EmployeeStatus,
      employeeStatusId,
      documentsToUpload,
      msgFile,
      showAprovacao,
      erroDelete,
      msgAlert,
      classText
    } = this.state;
    const {
      name,
      email,
      Sector,
      phone,
      cpf,
      rg,
      state,
      city,
      district,
      address,
      number,
      complement
    } = dataEmployee;
    return (
      <Fragment>
        <div className="row page-titles">
          <div className="col-md-5 col-8 align-self-center">
            <h3 className="text-themecolor">
              Documentos (Mensal) de Funcionário
              {load ? <i className="fa fa-spin fa-spinner" /> : null}
            </h3>
          </div>
        </div>

        <div className="row">
          <div className="m-b-10">
            <a
              href="../../documents-periodic"
              className="btn btn-rounded btn-outline-primary"
            >
              <i className="mdi mdi-arrow-left" />
            </a>
          </div>
          <div className="col-md-12 alert alert-primary">
            <span>
              Status da empresa:
              <strong> {localStorage.getItem("companyStatus")}</strong>
            </span>
          </div>
          <div className="col-md-12 alert alert-primary">
            <span>
              Status do funcionário {name}:<strong> {EmployeeStatus}</strong>
            </span>
          </div>
        </div>

        <form action="javascript:void(0)" id="formDocuments">
          <div className="row m-b-15">
            <div className="col-md-12">
              <fieldset>
                <div className="row detail-company">
                  <div className="col-md-4 p-10">
                    <strong className="text-primary p-10">Nome:</strong>
                    <span>{name}</span>
                  </div>
                  <div className="col-md-5 p-10">
                    <strong className="text-primary p-10">Email:</strong>
                    <span>{email}</span>
                  </div>
                  <div className="col-md-3 p-10">
                    <strong className="text-primary p-10">Setor:</strong>
                    {Sector ? (
                      <span>{Sector.name}</span>
                    ) : null}
                  </div>
                  <div className="col-md-4 p-10">
                    <strong className="text-primary p-10">Telefone:</strong>
                    <span>{phone}</span>
                  </div>
                  <div className="col-md-4 p-10">
                    <strong className="text-primary p-10">CPF:</strong>
                    <span>{cpf}</span>
                  </div>
                  <div className="col-md-4 p-10">
                    <strong className="text-primary p-10">RG:</strong>
                    <span>{rg}</span>
                  </div>
                  <div className="col-md-4 p-10">
                    <strong className="text-primary p-10">Estado:</strong>
                    <span>{state}</span>
                  </div>
                  <div className="col-md-4 p-10">
                    <strong className="text-primary p-10">Cidade:</strong>
                    <span>{city}</span>
                  </div>
                  <div className="col-md-4 p-10">
                    <strong className="text-primary p-10">Bairro:</strong>
                    <span>{district}</span>
                  </div>
                  <div className="col-md-8 p-10">
                    <strong className="text-primary p-10">Endereço:</strong>
                    <span>{address}</span>
                  </div>
                  <div className="col-md-4 p-10">
                    <strong className="text-primary p-10">Número:</strong>
                    <span>{number}</span>
                  </div>
                  <div className="col-md-12 p-10">
                    <strong className="text-primary p-10">Complemento:</strong>
                    <span>{complement}</span>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>

          <div className="row card">
            <div className="col-md-12">
              <div className="card-body">
                <h4 className="card-title">
                  Envio de documentos do funcionário para credenciamento de
                  empresa
                </h4>
                <DropMonthYear
                  year={year}
                  month={month}
                  handleChangeDate={this.handleChangeDate}
                />
                <div className="feeds" style={{ overflowX: "hidden" }}>
                  {documentsToUpload.length
                    ? documentsToUpload.map(item => {
                        return (
                          <div
                            key={item.id}
                            className={"row align-center"}
                            style={{ padding: "37px" }}
                          >
                            <i className={this.verifyDocumentIcon(item.id)} />
                            <div className="col-md-3">{item.description}</div>
                            <div className="col-md-2">
                              {this.verifyDocumentNote(item.id) ? (
                                <i className="text-danger label label-light-danger m-l-20">
                                  {this.verifyDocumentNote(item.id)}
                                </i>
                              ) : null}
                              {this.verifyDocumentExpired(item.id) ? (
                                <i className="text-danger label label-light-danger m-l-20">
                                  {this.verifyDocumentExpired(item.id)}
                                </i>
                              ) : null}
                            </div>
                            <div className="col-md-2">
                              {this.verifyDocument(item.id) ? (
                                <i
                                  alt={this.verifyDocument(item.id)}
                                  title={this.verifyDocument(item.id)}
                                  className={
                                    this.verifyDocument(item.id)
                                      ? "text-success label label-light-success"
                                      : "text-danger"
                                  }
                                >
                                  <i className="fa fa-check" />
                                  {this.verifyDocument(item.id).substr(0, 20) +
                                    "..."}
                                </i>
                              ) : null}
                            </div>
                            <div className="col-md-2">
                              {this.showFileButton(item.id) &&
                              this.verifyDocumentApplicable(item.id) !==
                                true ? (
                                <input
                                  type="file"
                                  style={{ width: "150px" }}
                                  id={item.id}
                                  onChange={this.uploadDocument}
                                />
                              ) : null}
                            </div>

                            <div className="col-md-2">
                              {/* Status 3 = Documentos rejeitados
                              Status 6 = Desabilitado */}
                              {this.showFileButton(item.id) ? (
                                <div key={item.id} className="text-right p-10">
                                  <input
                                    type="checkbox"
                                    checked={this.verifyDocumentApplicable(
                                      item.id
                                    )}
                                    name="not_applicable"
                                    value={item.id}
                                    id={"document_" + item.id}
                                    onClick={this.checkDocument}
                                  />
                                  <label htmlFor={"document_" + item.id}>
                                    {" "}
                                    Não Aplicável{" "}
                                  </label>
                                </div>
                              ) : null}
                            </div>
                          </div>
                        );
                      })
                    : null}
                </div>
              </div>
            </div>
            <div className="col-md-12 text-center p-20">
              {/* {this.state.documentsToUpload.length &&
                this.state.showAprovacao &&
                (this.state.employeeStatusId === 1 ||
                  this.state.employeeStatusId === 3) && ( */}
              {this.showSubmitButtonByStatusCompany() ? (
                <button
                  className="btn btn-success"
                  onClick={this.confirmAlterStatusEmployee}
                >
                  Enviar para aprovação
                </button>
              ) : null}

              {msgFile ? (
                <div className="alert alert-danger">{msgFile}</div>
              ) : null}

              {!showAprovacao &&
                (employeeStatusId === 1 || employeeStatusId === 3) && (
                  <div className="alert alert-danger">
                    Para enviar os documentos para aprovação é necessário anexar
                    todos os documentos!
                  </div>
                )}

              {employeeStatusId === 2 && (
                <div className="alert alert-info">
                  Documentos estão em processo de aprovação!
                </div>
              )}
            </div>
          </div>
        </form>

        <ModalConfirm
          title="Confirmação"
          msg="Tem certeza que deseja enviar os documentos do colaborador para aprovação?"
          load={this.state.load}
          function={this.alterStatusEmployee}
          msgError={erroDelete}
        />
        <ModalAlert
          title="Envio de Documento(s)"
          msg={msgAlert}
          function=""
          classText={classText}
        />
      </Fragment>
    );
  }
}

export default Company;
